import { createBrowserRouter } from "react-router-dom";
import { ConfigProvider, theme } from "antd";
import { useState, useEffect } from 'react';

import AuthGuard from '../../shared/guards/authGuard';
import LoginGuard from "../../shared/guards/loginGuard";

import AuthLayout from "./authLayout";
import ErrorPage from "../mainPages/errorPage";

import Login from "../authPages/login";
import ForgotPasswordPage from "../authPages/login/forgotPasswordPage";
import CreateAccountPage from "../authPages/login/createAccountPage";
// import { rootLoader } from "../../shared/helpers/rootLoader";

import SidebarLayout from "./sidebarLayout";
import DashboardPage from "../mainPages/dashboardPage";
import AssetsPage from "../mainPages/assetsPage";
import NetworkMapPage from "../mainPages/networkMapPage";
import ThreatPreventionPage from "../mainPages/threatPreventionPage";
import AlertsPage from "../mainPages/alertsPage";
import ReportsPage from "../mainPages/reportsPage";
import UserManagementPage from "../mainPages/userManagementPage";
import IntegrationsPage from "../mainPages/integrationsPage";
import SettingsPage from "../mainPages/settingsPage";

const LoadingScreen = () => (
    <div className="fixed inset-0 bg-background/50 backdrop-blur-sm flex items-center justify-center">
        <div>Loading...</div>
    </div>
);

// Create a wrapper component that will handle theme loading
const ThemedLayout = ({ children }) => {
    // Initialize theme based on localStorage, defaulting to light if null
    const getInitialTheme = () => {
        try {
            const themeMode = localStorage.getItem("data-bs-theme");
            // If null or not set, default to light theme
            if (themeMode === null || themeMode === undefined) {
                localStorage.setItem("data-bs-theme", "dark");
                return theme.defaultAlgorithm;
            }
            // Otherwise use the stored preference
            return themeMode === 'dark' ? theme.darkAlgorithm : theme.defaultAlgorithm;
        } catch (error) {
            console.error("Error loading theme:", error);
            return theme.defaultAlgorithm;
        }
    };

    const [themeConfig, setThemeConfig] = useState({
        algorithm: [getInitialTheme()],
        token: {
            fontFamily: `Inter, Helvetica, "sans-serif"`,
            fontSize: '1rem',
            fontWeight: 400
        }
    });
    
    useEffect(() => {
        try {
            const themeMode = localStorage.getItem("data-bs-theme");
            // console.log("themeMode", themeMode);
            
            // Update theme algorithm based on stored value
            const selectedAlgorithm = themeMode === 'dark' ? theme.darkAlgorithm : theme.defaultAlgorithm;
            
            setThemeConfig(prev => ({
                ...prev,
                algorithm: [selectedAlgorithm]
            }));
        } catch (error) {
            console.error("Error loading theme:", error);
        }
    }, []);
    
    return (
        <ConfigProvider theme={themeConfig}>
            {children}
        </ConfigProvider>
    );
};

// Create a component for the sidebar with theme
const ThemedSidebarLayout = () => (
    <ThemedLayout>
        <SidebarLayout />
    </ThemedLayout>
);

export const router = createBrowserRouter([
    {
        path: '/',
        element: <AuthGuard />,
        errorElement: <ErrorPage />,
        // loader: rootLoader,
        loading: <LoadingScreen />,
        children: [
            {
                path: "/",
                element: <ThemedSidebarLayout />,
                children: [
                    {
                        path: '/',
                        element: <DashboardPage />
                    },
                    {
                        path: '/dashboard',
                        element: <DashboardPage />
                    },
                    {
                        path: '/assets',
                        element: <AssetsPage />
                    },
                    {
                        path: '/network-map',
                        element: <NetworkMapPage />
                    },
                    {
                        path: '/threat-prevention',
                        element: <ThreatPreventionPage />
                    },
                    {
                        path: '/alerts',
                        element: <AlertsPage />
                    },
                    {
                        path: '/reports',
                        element: <ReportsPage />
                    },
                    {
                        path: '/user-management',
                        element: <UserManagementPage />
                    },
                    {
                        path: '/integrations',
                        element: <IntegrationsPage />
                    },
                    {
                        path: '/settings',
                        element: <SettingsPage />
                    }
                ]
            }
        ]
    },
    {
        element: <LoginGuard />,
        errorElement: <ErrorPage />,
        children: [
            {
                element: <ThemedLayout><AuthLayout /></ThemedLayout>,
                children: [
                    {
                        path: "/login",
                        element: <Login />,
                    },
                    {
                        path: "/forgot-password",
                        element: <ForgotPasswordPage />,
                    },
                    {
                        path: "/create-new-account",
                        element: <CreateAccountPage />,
                    }
                ]
            }
        ]
    },
    {
        path: "*",
        element: <ErrorPage />
    }
]);